import { render, staticRenderFns } from "./CheckoutButton.vue?vue&type=template&id=b5537d38&scoped=true"
import script from "./CheckoutButton.vue?vue&type=script&lang=js"
export * from "./CheckoutButton.vue?vue&type=script&lang=js"
import style0 from "./CheckoutButton.vue?vue&type=style&index=0&id=b5537d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5537d38",
  null
  
)

export default component.exports